import { render, staticRenderFns } from "./studentLeaveRequest.vue?vue&type=template&id=a99d95a0&scoped=true&"
import script from "./studentLeaveRequest.vue?vue&type=script&lang=js&"
export * from "./studentLeaveRequest.vue?vue&type=script&lang=js&"
import style0 from "./studentLeaveRequest.vue?vue&type=style&index=0&id=a99d95a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a99d95a0",
  null
  
)

export default component.exports